








































import {Vue, Component} from 'vue-property-decorator';

@Component({
  name: 'InformationCard',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    link: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    actionBtn: {
      type: String,
      default: '',
    },
    withoutOrangeLine: {
      type: Boolean,
      default: false,
    },
    showBackground: {
      type: Boolean,
      default: true,
    },
    mobIcon: {
      type: String,
      default: '',
    },
    topIcon: {
      type: String,
      default: '',
    },
    headerTitleSize: {
      type: String,
      default: 'h5',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.$route.name === 'reservation') {
      this.$gtm.trackEvent({
        eventCategory: 'rent_funnel',
        eventAction: 'click',
        eventLabel: 'payment_success',
        event: 'payment_success',
      });
    }
  },
})
export default class InformationCard extends Vue {}
